const GRADIENT_DIRECTION = {
    HORIZONTAL: 1,
    VERTICAL: 2,
    FROM_TOP_TO_BOTTOM: 3,
    FROM_BOTTOM_TO_TOP: 4
};

module.exports = {
    GRADIENT_DIRECTION
};



/** WEBPACK FOOTER **
 ** ../src/dash/api/lib/overlays/constants.js
 **/